import { ActivityTargetView } from "@sp-crm/core";

const cadenceNounByUnit: Record<string, string> = {
    Daily: "day",
    Weekly: "week",
    Monthly: "month",
};

export const describeCadence = (intervalCount: number, intervalUnit: string): string => {
    const noun = cadenceNounByUnit[intervalUnit] ?? intervalUnit.toLowerCase();
    return intervalCount === 1 ? `every ${noun}` : `every ${intervalCount} ${noun}s`;
};

export const describeTargets = (targets: ActivityTargetView[]): string => {
    const labels = targets.map(target => target.label);
    if (labels.length <= 1) {
        return labels[0] ?? "";
    }
    return `${labels.slice(0, -1).join(", ")} or ${labels[labels.length - 1]}`;
};
